import { useHistory } from 'react-router'
import { useAuth } from '@cannect/hooks/AuthContext'
import { usePrepareCart } from '@cannect/hooks/usePrepareCart'
import { useTokenApi } from '@cannect/hooks/useTokenApi'
import { deleteUser } from 'hooks/useSessionUser'
import { logoutServerSession } from 'services/api'

type LogoutTarget = string | { pathname: string; state?: unknown }

// Saída da conta usada pelo header e pelo carrinho do link (010, "Sair e
// entrar com outra conta"). Mesma limpeza que o header sempre fez.
export const useLogout = () => {
  const history = useHistory()
  const { deleteTokenApi } = useTokenApi()
  const { getRoles } = useAuth()
  const { clearOrderData, clearCart } = usePrepareCart()

  return (target: LogoutTarget = '/login') => {
    try {
      clearCart()
      clearOrderData()
      localStorage.removeItem('selectedProducts')
      localStorage.removeItem('selectedProductsMedice')
      localStorage.removeItem('@CANNECT:CHECKOUT_CART')
      localStorage.removeItem('@CANNECT:ORDER_CHECKOUT_CART_ID')
      localStorage.removeItem('@CANNECT:ORDER_CHECKOUT_CART')
      localStorage.removeItem('@CANNECT:RECIPE_WARNING')
      localStorage.removeItem('@CANNECT:CREDIT_SELECTION')
      localStorage.removeItem('@CANNECT:CARD_PIX_SELECTION')
      localStorage.removeItem('@CANNECT:CARD_BOLETO_SELECTION')
      localStorage.removeItem('@CANNECT:TWO_CARDS_SELECTION')
      localStorage.removeItem('@CANNECT:SELECTED_CARD_EXTERNAL_ID')
    } catch (e) {
      // noop
    }
    // Revoga a família do refresh no servidor e limpa o cookie httpOnly
    // (fire-and-forget: a rota é baseada no próprio cookie, não no access).
    logoutServerSession()
    deleteTokenApi()
    deleteUser()
    getRoles()
    history.push(target as any)
  }
}
